/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CompanyId} from "./companyId.zod";

export const ConvertLeadToClientRequest = zod.object({
  companyId: CompanyId,
});

export type ConvertLeadToClientRequest = zod.input<typeof ConvertLeadToClientRequest>;
export type ConvertLeadToClientRequestOutput = zod.output<typeof ConvertLeadToClientRequest>;
